import { CommApiInstance } from "Utils/CommApiInstance";


const MbpAthnTknCrtRqstApi = async (
    athnPrpsCd:string,
    loginId:string|null,
    mktgAgreYn?:string|null,
) => {
    return await CommApiInstance.post(`athn/idnt_mthd/mbp/rqst_tkn_crt`,{
        apiBody: {
            athnPrpsCd:athnPrpsCd,
            loginId:loginId,
            smsMktgAgreYn:mktgAgreYn,
        }
    })
    .then((Resp) => Resp.data);
}

export default MbpAthnTknCrtRqstApi;